import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
const skeletonDistributorListing = ({ rows = 5 }) => {
  return (
    <div className='row distributor-table-row mb-4rem'>
      <div className='col-12'>
        <div className='card mt-0 distributor-list-card'>
          <div className="card-body mb-2">
            <div className="table-responsive distributor-table-responsive">
              <table className="table table-borderless table-list distributor-table-list">
                <thead>
                  <tr>
                    <th><div>DISTRIBUTOR</div></th>
                    <th><div>DISTRIBUTOR TYPE</div></th>
                    <th><div>COMPANY NAME</div></th>
                    <th><div>EMAIL</div></th>
                    <th><div>ASSIGNED ENGINEER</div></th>
                    <th><div>COUNTRY</div></th>
                    <th><div>STATUS</div></th>
                    <th><div>ACTIONS</div></th>
                  </tr>
                </thead>

                <tbody>
                  {Array.from({ length: rows }).map((_, index) => (
                    <tr key={index}>
                      <td className='clickable-cell'>
                        <div className='distributor-cell'>
                          <div className='mr-2'>
                            <Skeleton width={32} height={15} />
                          </div>
                          <h5>
                            <Skeleton width={233} height={15} />
                          </h5>
                        </div>
                      </td>
                      <td><Skeleton width={104} height={15} /></td>
                      <td><Skeleton width={122} height={15} /></td>
                      <td><Skeleton width={120} height={15} /></td>
                      <td><Skeleton width={50} height={15} /></td>
                      <td><Skeleton width={50} height={15} /></td>
                      <td><Skeleton width={60} height={15} /></td>
                      <td className='text-center'>
                        <Skeleton width={20} height={15} />
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default skeletonDistributorListing;